<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>选择商家</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称" prop="merchantName">
                <a-input v-model="queryParam.merchantName" :maxLength="32" :placeholder="$t('请输入')+'商家名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="经营类型" prop="selfType">
                <a-select :placeholder="$t('请选择')+'经营类型'" v-model="queryParam.selfType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SelfTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <div>
        <a-row>
            <!-- 数据展示 -->
            <a-table
              :loading="loading"
              :size="tableSize"
              rowKey="id"
              :columns="columns"
              :data-source="list"
              :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio', onChange: onSelectChange}"
              :pagination="false"
              :customRow="loadCustomRow"
              :bordered="tableBordered">
              <template slot="merchantLogo" slot-scope="text, record">
                <div>
                  <img v-if="record.merchantLogo" :src="record.merchantLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.merchantLogo)" alt="none"/>
                </div>
              </template>
            </a-table>
            <!-- 分页 -->
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              show-quick-jumper
              :pageSizeOptions="pageSizeOptions"
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :showTotal="total => getTotal(total)"
              @showSizeChange="onShowSizeChange"
              @change="changeSize"
            />
        </a-row>
      </div>

    </a-card>
  </a-modal>
</template>

<script>
import {listSelectMerchant, pageSelectMerchant} from '@/api/merchant/merchantMerchant'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor";
import {tableMixin} from '@/store/table-mixin'
import textArea from "@/components/TextArea";


export default {
  name: 'RadioMerchantSelectForm',
  props: {},
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      idText: '',
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantName: undefined,
        merchantStatus: undefined,
        selfType: undefined,
        businessType: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '商家logo',
          dataIndex: 'merchantLogo',
          scopedSlots: {customRender: 'merchantLogo'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          ellipsis: true,
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQuery()
      this.textarea = ''
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param id
     */
    openGoods( id) {
        // 对源数据深度克隆
      if (id) {
        this.selectedRowKeys = [id];
        this.queryParam.orderByIdList = this.selectedRowKeys;
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('merchantSelected', this.selectedRows[0])
      this.resetQuery()
      this.idText = ''
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQuery()
      this.idText = ''
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSelectMerchant(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        merchantName: undefined,
        selfType: undefined,
        merchantStatus: undefined,
        businessType: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRows.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          dblclick: () => {
            this.onOk()
          },
        }
      }
    },

    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
  }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>
